var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Route } from "react-router";
import { NestedRoute, IndexRedirect } from "@irati/utils/history/routing";
import Home, { RedemptionDrilldown } from "../containers/ReportingV3";
var ReportingV3 = /** @class */ (function (_super) {
    __extends(ReportingV3, _super);
    function ReportingV3() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReportingV3.prototype.render = function () {
        var match = this.props.match;
        return (React.createElement(Route, { path: match.url, render: function () { return (React.createElement(React.Fragment, null,
                React.createElement(IndexRedirect, { match: match.url, to: "/home" }),
                React.createElement(NestedRoute, { match: match.url, path: "/home", component: Home, title: "Admin Reporting" }),
                React.createElement(NestedRoute, { match: match.url, path: "/redemptions", component: RedemptionDrilldown, title: "Redemption Drilldown Report" }))); } }));
    };
    return ReportingV3;
}(PureComponent));
export default ReportingV3;
